module.exports = __webpack_public_path__ + "18b95684fbbf35be53d478743dba82cb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/paint-palette.png
// module id = 2415
// module chunks = 0